"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerLevelBetAmountsListCtl = /** @class */ (function (_super) {
    __extends(PlayerLevelBetAmountsListCtl, _super);
    function PlayerLevelBetAmountsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_bonus_level_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_level_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_min_bet_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_bet_amount; });
        _this.dk_points_exchange_money_price = UIUtils_1.UIUtils.IProp2Str(function (o) { o.points_exchange_money_price; });
        _this.dk_points_exchange_min_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.points_exchange_min_amount; });
        _this.dk_cashback_bonus_percent_x100 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cashback_bonus_percent_x100; });
        _this.dk_cashback_bonus_wager = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cashback_bonus_wager; });
        _this.dk_birthday_bonus_wager = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_bonus_wager; });
        _this.dk_birthday_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.birthday_bonus_amount; });
        _this.dk_level_access_bonus_wager = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_access_bonus_wager; });
        _this.dk_level_access_bonus_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_access_bonus_amount; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerLevelBetAmountsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerLevelBetAmountsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player level title with id [" + id + "] not found !";
    };
    PlayerLevelBetAmountsListCtl.prototype.LoadData = function (LevelId, onDone) {
        var _this = this;
        webAApi_1.ListBonusPlayerLevelBetAmountsByLevelIdGet.exec({
            bonus_player_level_id: LevelId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    bonus_level_title: resp.list[i].bonus_level_title,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    min_bet_amount: resp.list[i].min_bet_amount,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    points_exchange_money_price: resp.list[i].points_exchange_money_price,
                    points_exchange_min_amount: resp.list[i].points_exchange_min_amount,
                    cashback_bonus_percent_x100: resp.list[i].cashback_bonus_percent_x100,
                    cashback_bonus_wager: resp.list[i].cashback_bonus_wager,
                    birthday_bonus_wager: resp.list[i].birthday_bonus_wager,
                    birthday_bonus_amount: resp.list[i].birthday_bonus_amount,
                    level_access_bonus_wager: resp.list[i].level_access_bonus_wager,
                    level_access_bonus_amount: resp.list[i].level_access_bonus_amount
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerLevelBetAmountsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusPlayerLevelBetAmount.exec({
            data: {
                brand_bonus_level_id: data.brand_bonus_level_id,
                app_currency_id: data.app_currency_id,
                min_total_bet_amount: data.min_total_bet_amount,
                points_exchange_money_price: data.points_exchange_money_price,
                points_exchange_min_amount: data.points_exchange_min_amount,
                cashback_bonus_percent_x100: data.cashback_bonus_percent_x100,
                cashback_bonus_wager: data.cashback_bonus_wager,
                birthday_bonus_wager: data.birthday_bonus_wager,
                birthday_bonus_amount: data.birthday_bonus_amount,
                level_access_bonus_wager: data.level_access_bonus_wager,
                level_access_bonus_amount: data.level_access_bonus_amount
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                bonus_level_title: resp.brand_bonus_level_title,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                min_bet_amount: data.min_total_bet_amount,
                points_exchange_money_price: data.points_exchange_money_price,
                points_exchange_min_amount: data.points_exchange_min_amount,
                cashback_bonus_percent_x100: data.cashback_bonus_percent_x100,
                cashback_bonus_wager: data.cashback_bonus_wager,
                birthday_bonus_wager: data.birthday_bonus_wager,
                birthday_bonus_amount: data.birthday_bonus_amount,
                level_access_bonus_wager: data.level_access_bonus_wager,
                level_access_bonus_amount: data.level_access_bonus_amount
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerLevelBetAmountsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusPlayerLevelBetAmount.exec({
                data: {
                    brands_player_level_betamount_id: data.key,
                    min_total_bet_amount: data.min_total_bet_amount,
                    points_exchange_money_price: data.points_exchange_money_price,
                    points_exchange_min_amount: data.points_exchange_min_amount,
                    cashback_bonus_percent_x100: data.cashback_bonus_percent_x100,
                    cashback_bonus_wager: data.cashback_bonus_wager,
                    birthday_bonus_wager: data.birthday_bonus_wager,
                    birthday_bonus_amount: data.birthday_bonus_amount,
                    level_access_bonus_wager: data.level_access_bonus_wager,
                    level_access_bonus_amount: data.level_access_bonus_amount
                }
            }, function (resp) {
                _tmp.min_bet_amount = data.min_total_bet_amount;
                _tmp.points_exchange_money_price = data.points_exchange_money_price;
                _tmp.points_exchange_min_amount = data.points_exchange_min_amount;
                _tmp.cashback_bonus_percent_x100 = data.cashback_bonus_percent_x100;
                _tmp.cashback_bonus_wager = data.cashback_bonus_wager;
                _tmp.birthday_bonus_wager = data.birthday_bonus_wager;
                _tmp.birthday_bonus_amount = data.birthday_bonus_amount;
                _tmp.level_access_bonus_wager = data.level_access_bonus_wager;
                _tmp.level_access_bonus_amount = data.level_access_bonus_amount;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerLevelBetAmountsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PlayerLevelBetAmountsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusPlayerLevelBetAmount.exec({
                data: {
                    brands_player_level_betamount_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerLevelBetAmountsListCtl;
}(BaseController_1.BaseController));
exports.PlayerLevelBetAmountsListCtl = PlayerLevelBetAmountsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ctl/PlayerLevelBetAmountsListCtl.ts
// module id = 932
// module chunks = 0